export const MAXIMUM_RATING_STARS = 5;
